import * as React from 'react';

import { Card } from '@blueprintjs/core';

import CardContainer from '../common/CardContainer';
import AdminNavBar from './AdminNavBar';

import Sections from '../../components/admin/sections';
import AdminEditOfficePage from '../../components/admin/sections/AdminEditOfficePage';
import AdminCreateOfficePage from '../../components/admin/sections/AdminCreateOfficePage';
// import ConfigPage from './sections/ConfigPage';

import { Switch, RouteComponentProps } from 'react-router-dom';
import RoutePrivate from '../router/RoutePrivate';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import UserDetails from 'src/models/UserDetails';
import Permissions from 'src/models/Permissions';

export const adminBasePath = '/admin';

interface IAdminPageStateProps {
    isLoggedIn: boolean;
    user: UserDetails;
}

export interface IAdminPageDispatchProps {
    navigate: (path: string) => void;
}

type IAdminPageProps = RouteComponentProps & IAdminPageStateProps & IAdminPageDispatchProps;

class AdminPage extends React.Component<IAdminPageProps> {
    public render() {
        return (
            <CardContainer>
                <Card elevation={1}>
                    <div className="card-header">Admin</div>
                    <AdminNavBar
                        matchUrl={adminBasePath}
                        location={this.props.location.pathname}
                        user={this.props.user}
                        navigate={this.props.navigate}
                    />
                    <Switch>
                        <RoutePrivate
                            key="admin-roles"
                            path={adminBasePath + '/roles'}
                            component={Sections.Roles}
                            isLoggedIn={this.props.isLoggedIn}
                            user={this.props.user}
                            permissions={[Permissions.RolesManage, Permissions.UserRolesManage]}
                        />
                        <RoutePrivate
                            key="admin-user"
                            path={adminBasePath + '/users'}
                            component={Sections.Users}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-client"
                            path={adminBasePath + '/clients'}
                            component={Sections.Clients}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-create-user"
                            path={adminBasePath + '/create-user'}
                            component={Sections.CreateUser}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="admin-edit-user"
                            path={adminBasePath + '/edit-user/:userId'}
                            component={Sections.CreateUser}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="list-office"
                            path={adminBasePath + '/offices'}
                            component={Sections.Offices}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="edit-office"
                            path={adminBasePath + '/edit-office/:id'}
                            component={AdminEditOfficePage}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        <RoutePrivate
                            key="create-office"
                            path={adminBasePath + '/create-office'}
                            component={AdminCreateOfficePage}
                            isLoggedIn={this.props.isLoggedIn}
                        />
                        {/* <RoutePrivate
                            key="config"
                            path={adminBasePath + '/config'}
                            component={ConfigPage}
                            isLoggedIn={this.props.isLoggedIn}
                        /> */}
                    </Switch>
                </Card>
            </CardContainer>
        );
    }
}

const mapStateToProps = (state: IRootState) => ({
    isLoggedIn: selectors.auth.isLoggedIn(state),
    user: selectors.auth.user(state),
});

const mapDispatchToProps: IAdminPageDispatchProps = {
    navigate: (path: string) => push(path),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);



// WEBPACK FOOTER //
// ./src/components/admin/AdminPage.tsx